import React, { useEffect, useState } from 'react'

import { getBaseURL } from '../../global/environments/index.js'
import { encodeForURL } from '../../global/formatters/string-formatter.js'

export default function TextInputRedirect({ path, label }) {
  const [baseUrl, setBaseUrl] = useState('')
  const [queryParam, setQueryParam] = useState('')

  useEffect(() => {
    const base = getBaseURL()
    setBaseUrl(base)
  }, [])

  const handleInputChange = (event) => {
    setQueryParam(event.target.value)
  }

  const handleSubmit = (event) => {
    window.location.href = encodeForURL(
      `${baseUrl}${path}?search=${queryParam}`
    )

    event.preventDefault()
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="Input-group u-marginRight4gu">
        <input
          className="search-filter Input Input--withIconLeft u-textUppercase u-textSecondary"
          type="text"
          name={label}
          placeholder={label}
          value={queryParam}
          onChange={handleInputChange}
        />
        <span
          className="Input-icon Icon--before Icon--cti"
          data-icon="&#xf122;"
        ></span>
      </div>
    </form>
  )
}
